import posthog from 'posthog-js'

let initialized = false

export function initPostHog() {
  if (initialized) return
  if (typeof window === 'undefined') return

  const key = import.meta.env.VITE_POSTHOG_KEY
  const host = import.meta.env.VITE_POSTHOG_HOST

  if (!key) {
    console.warn('[PostHog] VITE_POSTHOG_KEY not set, analytics disabled')
    return
  }

  posthog.init(key, {
    api_host: host || '/relay-turn',
    person_profiles: 'identified_only',
    cross_subdomain_cookie: true,
    persistence: 'localStorage+cookie',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-no-capture]',
    },
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.debug()
    },
  })

  initialized = true
}

interface IdentifyProps {
  userId: string
  email?: string | null
  name?: string | null
  createdAt?: string | null
  role?: string | null
  hasActiveSubscription?: boolean | null
}

export function identifyUser(props: IdentifyProps) {
  if (typeof window === 'undefined') return
  if (!initialized) return

  const { userId, ...rest } = props

  const personProps: Record<string, unknown> = {}
  for (const [k, v] of Object.entries(rest)) {
    if (v !== null && v !== undefined) personProps[k] = v
  }

  posthog.identify(userId, personProps)
}

export function resetUser() {
  if (typeof window === 'undefined') return
  if (!initialized) return
  posthog.reset()
}

export { posthog }
